import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const CountriesLoadable = Loadable({
    loader: (): any => import('./Countries').then((res) => res.Countries),
    loading: <Loader/>,
});
